import axios from "axios";
import toast from "react-hot-toast";

const errorHandler = (error: unknown, skipToast = false): { message: string; status?: number } => {
  const defaultError = { message: "An unexpected error occurred." };

  if (axios.isAxiosError(error)) {
    if (error.response) {
      console.error("Error response:", error.response.data);
      
      const errorData = error.response.data;
      let errorMessage = "Server error occurred.";
      
      if (errorData?.errors && Array.isArray(errorData.errors) && errorData.errors.length > 0) {
        errorMessage = errorData.errors[0]?.messages?.[0] || errorMessage;
      } else if (errorData?.message) {
        errorMessage = errorData.message;
      } else if (errorData?.item?.acknowledge) {
        errorMessage = errorData.item.acknowledge;
      }
      
      if (!skipToast) {
        toast.error(errorMessage);
      }
      return {
        message: errorMessage,
        status: error.response.status,
      };
    } else if (error.request) {
      console.error("Error request:", error.request);
      if (!skipToast) {
        toast.error("No response received from the server.");
      }
      return { message: "No response received from the server." };
    } else {
      console.error("Error message:", error.message);
      if (!skipToast) {
        toast.error(error.message || "Error in setting up the request.");
      }
      return { message: error.message || "Error in setting up the request." };
    }
  } else {
    console.error("Error:", error);
    const errorObj = error as Error;
    if (errorObj?.message && !errorObj.message.includes("Something went wrong")) {
      if (!skipToast) {
        toast.error(errorObj.message);
      }
      return { message: errorObj.message };
    }
    if (!skipToast) {
      toast.error(defaultError.message);
    }
    return defaultError;
  }
};

export default errorHandler;
